var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "app sidebar-fixed aside-menu-fixed aside-menu-hidden agent-portal-admin",
      staticStyle: { "background-color": "#F7F7F7" }
    },
    [
      _c("skip-to-content"),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "background-color": "#F7F7F7" } },
        [
          _c("navigationtop"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "app-body" },
            [
              _c("navigation"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "main bg-white",
                  attrs: { id: "main-content", role: "main" }
                },
                [
                  _c(
                    "b-container",
                    { attrs: { fluid: "" } },
                    [
                      _c("breadcrumbs"),
                      _vm._v(" "),
                      _c("section-alerts"),
                      _vm._v(" "),
                      _vm.$route.name === "admin/dashboard"
                        ? _c("div", [_c("dashboard")], 1)
                        : _c("router-view"),
                      _vm._v(" "),
                      _vm.showModal
                        ? _c(
                            "div",
                            { attrs: { id: "reportsDownloadModal" } },
                            [
                              _c("reports-download", {
                                on: {
                                  displayModal: function($event) {
                                    _vm.showModal = !_vm.showModal
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c3c83df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c3c83df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/Admin.vue
// module id = null
// module chunks = 